// src/pages/ResourceHubPage.jsx
import React, { useState } from 'react';
import { ArrowLeft, Book, Zap, AppWindow, Link as LinkIcon } from 'lucide-react';

// Data taken directly from the tables in your research document
const resources = [
  // Textbooks [cite: 172]
  { id: 1, type: 'Textbook', level: 'A1-B1', title: 'Menschen, Momente', publisher: 'Hueber', description: 'Commonly used in language schools, good structure for beginners.' },
  { id: 2, type: 'Textbook', level: 'B1-C1', title: 'Sicher!, Aspekte neu', publisher: 'Hueber, Klett', description: 'Standard for intermediate and advanced courses, focuses on exam-relevant topics.' },
  { id: 3, type: 'Textbook', level: 'B1-C2', title: 'Mittelpunkt', publisher: 'Klett', description: 'Comprehensive series, entirely in German, suitable for immersive learning.' },
  // Grammar Guides [cite: 174]
  { id: 4, type: 'Grammar', level: 'A1-B1', title: 'Grammatik aktiv', publisher: 'Cornelsen', description: 'Practical exercises with visual aids, good for applying grammar rules.' },
  { id: 5, type: 'Grammar', level: 'B1-C1', title: 'Übungsgrammatik für die Mittelstufe', publisher: '', description: 'Extensive drills for solidifying intermediate and advanced grammar.' },
  { id: 6, type: 'Grammar', level: 'B1-C2', title: "Hammer's German Grammar and Usage", publisher: 'Routledge', description: 'The definitive, comprehensive reference for in-depth explanations.' },
  // Digital Tools [cite: 176]
  { id: 7, type: 'App', level: 'All Levels', title: 'Anki / Heylama', publisher: 'SRS App', description: 'Building and maintaining a large, active vocabulary base.' },
  { id: 8, type: 'App', level: 'A1-B2', title: 'Busuu', publisher: 'Course App', description: 'Structured, CEFR-based lessons covering all four skills.' },
  { id: 9, type: 'App', level: 'All Levels', title: 'iTalki / Preply', publisher: 'Tutoring Platform', description: 'One-on-one speaking practice and personalized feedback.' },
  { id: 10, type: 'App', level: 'A1-C1', title: 'DW Learn German', publisher: 'Online Course/Media', description: 'Comprehensive free resources, including "Nicos Weg" video course.' },
];

const ResourceCard = ({ resource }) => (
    <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200 flex flex-col hover:-translate-y-1 transition-transform">
        <div className="flex-grow">
            <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-blue-100 rounded-lg text-blue-600">
                    {resource.type === 'Textbook' && <Book className="w-5 h-5"/>}
                    {resource.type === 'Grammar' && <Book className="w-5 h-5"/>}
                    {resource.type === 'App' && <AppWindow className="w-5 h-5"/>}
                </div>
                <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-semibold">{resource.level}</span>
            </div>
            <h3 className="text-lg font-bold text-gray-900">{resource.title}</h3>
            <p className="text-sm text-gray-500 mb-4">{resource.publisher}</p>
            <p className="text-sm text-gray-600">{resource.description}</p>
        </div>
        <button className="mt-6 w-full flex items-center justify-center bg-slate-100 text-slate-700 px-4 py-2.5 rounded-lg font-semibold hover:bg-slate-200 transition-colors">
            <LinkIcon className="w-4 h-4 mr-2" />
            Zur Ressource
        </button>
    </div>
);


const ResourceHubPage = ({ onBack }) => {
    const [filter, setFilter] = useState('All');
    const filters = ['All', 'Textbook', 'Grammar', 'App'];

    const filteredResources = resources.filter(r => filter === 'All' || r.type === filter);

    return (
    <div className="animate-fade-in bg-slate-50 min-h-full">
        <div className="bg-white border-b border-gray-200">
            <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
                <div className="flex items-center gap-4">
                    <button onClick={onBack} className="text-gray-500 hover:text-gray-900"><ArrowLeft className="w-6 h-6" /></button>
                    <div>
                        <h1 className="text-4xl font-bold text-gray-900">Ressourcen-Hub</h1>
                        <p className="mt-1 text-lg text-gray-600">Von Experten empfohlene Bücher, Apps und Werkzeuge.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
            {/* Filter Tabs */}
            <div className="mb-8 flex items-center justify-center border-b border-gray-200">
                <div className="flex space-x-2">
                {filters.map(f => (
                    <button
                        key={f}
                        onClick={() => setFilter(f)}
                        className={`px-4 py-2 font-semibold text-sm rounded-t-lg transition-colors ${
                            filter === f ? 'bg-white border-gray-200 border-t border-x text-blue-600' : 'text-gray-500 hover:bg-gray-100'
                        }`}
                    >
                        {f === 'All' ? 'Alle' : f}
                    </button>
                ))}
                </div>
            </div>

            {/* Resources Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredResources.map(resource => (
                    <ResourceCard key={resource.id} resource={resource} />
                ))}
            </div>
        </div>
    </div>
  );
};

export default ResourceHubPage;